import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import React from "react";

import {useTranslation} from "react-i18next";

type Props = {
  open: boolean;
  isError?: boolean
  onClose?(): void;
  message: string
  title?: string
  action?: React.ReactNode
  noCloseButton?: boolean
  anchorOrigin?: SnackbarOrigin
  autoHideDuration?: number | null
}

const AlertBottom = ({
  open,
  onClose,
  message,
  title,
  action,
  noCloseButton,
  isError,
  anchorOrigin,
  autoHideDuration = 2000,
}: Props) => {
  const { t } = useTranslation()

  const handleClose = noCloseButton ? undefined : onClose
  const actionSlotProps = action ? {
    action: {
      sx: {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        marginRight: 0,
        paddingTop: 0,
      },
    },
  } : undefined

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={anchorOrigin || {
        vertical: 'bottom',
        horizontal: 'left' }}
      autoHideDuration={autoHideDuration}
    >
      <Alert
        action={action}
        onClose={handleClose}
        severity={isError ? 'error' : 'info'}
        slotProps={actionSlotProps}
        sx={{
          boxSizing: 'border-box',
          width: '100%',
          maxWidth: 560,
        }}
      >
        <AlertTitle>{title || (isError ? t('errors__message__commonError') : t('common__text__done'))}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default AlertBottom
